// let currentDate = new Date();
// let currentTimestampInMilliseconds = currentDate.getTime();
// let unixTimestamp = Math.floor(currentTimestampInMilliseconds / 1000);
// export default unixTimestamp;

function getUnixTimestamp() {
  let currentDate = new Date();
  let currentTimestampInMilliseconds = currentDate.getTime();
  let unixTimestamp = Math.floor(currentTimestampInMilliseconds / 1000);
  return unixTimestamp;
}

export default getUnixTimestamp;
